import styled from 'styled-components';
import { MaterialDesignContent } from 'notistack';

export const StyledMaterialDesignContent = styled(MaterialDesignContent)(
  ({ theme }) => ({
    '&.notistack-MuiContent': {
      color: theme.palette.common.black,
      fontFamily: theme.fontFamily,
      fontOpticalSizing: 'auto',
      fontSize: theme.utils.pxToRem(16),
      fontStyle: 'normal',
      fontWeight: 500,
      lineHeight: theme.utils.pxToRem(24),
    },
    '&.notistack-MuiContent-success': {
      color: theme.palette.common.black,
      backgroundColor: `${theme.palette.success}`,
    },
    '&.notistack-MuiContent-error': {
      color: theme.palette.common.white,
      backgroundColor: `${theme.palette.error}`,
    },
  }),
);
